<template>
  <div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!--Slide 1-->
      <div
        class="swiper-slide overflow-auto swiper-no-swiping"
        data-title="2.1. Estadios del desarrollo / pág. 1"
      >
        <div class="container-fluid margen_principal">
          <div class="row mb-4">
            <div class="col-xl-6 col-lg-6 col-12">
              <h3>2.1. Estadios del desarrollo</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-12">
              <p>
                En miras a responder la pregunta por el desarrollo infantil,
                surge un concepto clave en La teoría de Piaget (1970) de Mussen,
                P., denominado los estadios. Esta es la organización que plantea
                para designar una serie de períodos que tienen que transcurrir
                entre la etapa del recién nacido hasta el momento de la
                juventud. Los estadios han sido una figura altamente productiva
                en la psicología, como ocurre con el psicoanálisis (anal, oral),
                la psicología evolutiva y, por ende, en la psicología del
                desarrollo. Así, estas etapas son momentos evolutivos en los
                cuales se marca un paso a paso a cada etapa del desarrollo que
                se sustenta en criterios como son los períodos de ciclos, en los
                cuales un estadio transcurre tras el otro; también, se adecúan a
                los ritmos de aprendizaje de cada individuo, lo que implica que
                su velocidad no sea equivalente para todos los seres humanos.
                Por otro lado, la inclusión de un estadio en otro hace que se
                identifique que las etapas no ocurren de manera abrupta, sino
                que se pueden presentar dos estadios en un mismo momento.
              </p>
            </div>
            <div class="col-xl-5 col-lg-5 col-12 offset-xl-1 offset-lg-1">
              <p>
                Para Perinat (2004), los estadios buscan responder a la cuestión
                sobre ¿cómo pasa el niño de sus primeros reflejos a la capacidad
                de abstracción? Para esto, el autor alude, más que a unas etapas
                de un circuito que los niños y niñas deben recorrer para llegar
                a un fin determinado, a un edificio. Ese se compone de unas
                estructuras en las cuales se va subiendo para poder construir la
                inteligencia y el conocimiento. Así, cada paso marca una
                elaboración de un paso dado donde se avanza despacio, allí se
                privilegia el camino andado, el cual va transformando el
                tránsito futuro. Estos estadios son: sensorio-motor,
                preoperacional, operaciones concretas y operaciones formales.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-12 offset-xl-4 offset-lg-4">
              <audio controls="" class="w-100" controlslist="nodownload">
                <source
                  src="recursos/audio/au_u2_INLIN_slide17.mp3"
                  type="audio/mpeg"
                />
              </audio>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-12 offset-xl-3 offset-lg-3">
              <div class="row mt-3 cuadroGAVI ml-lg-4">
                <div
                  class="col-lg-3 col-md-3 col-sm-12 col-12 align-items-center d-flex justify-content-center"
                >
                  <img
                    src="recursos/img/GAVI/Importante.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                  <p class="tal">¡Importante!</p>
                  <p>
                    Observa el siguiente video para que puedas apreciar la
                    primera parte sobre la teoría de Piaget, explicada por él
                    mismo:
                  </p>
                  <p>
                    YALE UNIVERSITY [Vicente Panuccio]. (28 de mayo de 2013).
                    PIAGET explica a PIAGET (1 de 3) [Archivo de video].
                    Recuperado de
                    <span class="url"
                      ><a
                        href="https://www.youtube.com/watch?v=NuDjscvqE08&t=52s"
                        target="_blank"
                        >https://www.youtube.com/</a
                      ></span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-xl-6 col-lg-6 col-12">
              <h4>2.1.1. Estadio sensorio-motor</h4>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-xl-6 col-lg-6 col-12">
              <p>
                Este período transcurre de los cero (0) a los dos (2) primeros
                años de vida del infante. Se considera como la primera de las
                etapas del desarrollo, porque establece un punto de partida. La
                caracterización inicial que se tiene de este momento es la
                relación primaria que tienen los bebés con los aspectos
                sensoriales, lo que implica un conocimiento del mundo desde los
                sentidos. Para Mussen, P. (1970), en este momento se dan las
                manifestaciones en los niños y niñas de las experiencias de los
                objetos, la existencia de un mundo real que puede ser palpado, y
                que dichos objetos se constituyen de un volumen, textura,
                temperatura y dimensiones que pueden ser abarcadas. Linares, R.
                (2005) explica cómo en este escenario se proyectan las
                reacciones circulares, que son:
              </p>
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
              <h6 class="font-italic text-center">
                Haga clic en los botones para ampliar la información de las
                reaciones circulares.
              </h6>
              <div>
                <b-card no-body class="tabs">
                  <b-tabs class="cabeceraTabs">
                    <b-tab no-body class="p-3 navTab" title="1">
                      <h5>Primarias</h5>
                      <p class="p-0 m-0">
                        Aluden a los procesos que tienen incidencia en el cuerpo
                        del niño (sacar la lengua, el movimiento de los ojos).
                      </p>
                    </b-tab>

                    <b-tab no-body class="p-3" title="2">
                      <h5>Secundarias</h5>
                      <p class="p-0 m-0">
                        Se presenta el manejo de los objetos que son manipulados
                        y examinados.
                      </p>
                    </b-tab>

                    <b-tab no-body class="p-3" title="3">
                      <h5>Terciarias</h5>
                      <p class="p-0 m-0">
                        Se comprende la exploración que realizan los niños y
                        niñas de todo aquello cuanto les rodea, como una
                        búsqueda activa por sentir y configurar un patrón
                        general sobre el mundo circundante.
                      </p>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
          <div class="row Fondo2Ppal p-3">
            <div class="col-12">
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-12">
                  <p>
                    En el estadio sensorio-motor, se jerarquiza una serie de
                    subperíodos que transcurren acorde a los períodos de tiempo
                    de desarrollo de los infantes.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
              <h6 class="text-center font-italic">
                Haga clic en los botones para cada uno de los subperíodos.
              </h6>
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.accordion-1 class="btnColapsable"
                      >Organización y adaptación</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-1"
                    visible
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <h5>Primer subperíodo</h5>
                      <p>
                        Ocurre en el primer mes de nacimiento y es descrito,
                        según Perinat (2004), como el momento en el cual se
                        aplican los esquemas de acción. Estos son una serie de
                        actos reflejos hereditarios, en los cuales se proyectan
                        las acciones de succionar, agarrar, apretar, mirar, etc.
                        En esta situación los reflejos obedecen principalmente a
                        estímulos fisiológicos-orgánicos que se van organizando
                        y adaptando a la exterioridad. De allí que sea un
                        misterio el saber cómo las estructuras previas y las
                        reacciones motrices a los estímulos sensoriales del
                        contexto se van convirtiendo en un patrón evolutivo del
                        desarrollo, que a partir de esquemas fisiológicos llevan
                        a un comportamiento mediado por la cognición.
                      </p>
                      <p>
                        En este subperíodo se logra identificar el modo como los
                        bebés se van acomodando al contacto con la madre, a
                        partir de la posición de los labios, la extensión y
                        flexión de la mano para lograr el agarre y la succión
                        que hace el lactante. Estos movimientos se convierten en
                        un patrón que, luego de tener una acomodación, la
                        adaptación del sujeto con el ambiente pasa a realizarse,
                        es decir, la asimilación, en la cual se comprenden los
                        cambios cognoscitivos.
                      </p>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-0">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.accordion-2 class="btnColapsable"
                      >Asimilación y acomodación</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-2"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <h5>Segundo subperíodo</h5>
                      <p>
                        Aquí vuelve el concepto de
                        <span class="font-italic">reacción circular</span>, el
                        cual Piaget (2007) describe como el surgimiento de unas
                        conductas en los niños y niñas que comienzan a emerger
                        en el tiempo de los primeros cuatro (4) meses de
                        nacimiento. En este tiempo, ocurre que los niños y niñas
                        buscan reorganizar esquemas que permiten controlar los
                        movimientos reflejos que ocurren en actividades como
                        chupar el dedo o agarrar un objeto; estas acciones
                        suelen realizarse de forma refleja, sin un control
                        determinado de los movimientos. Por lo tanto, en este
                        período, se explica cómo dichas acciones logran un
                        proceso de acomodación, permitiendo una coordinación
                        motora que sea controlable, como es el caso de subir la
                        mano, acercarla a la boca, seleccionar el dedo y
                        succionarlo.
                      </p>
                      <p>
                        Lograr este patrón en el lactante solo es posible por
                        múltiples intentos de acomodación, en los cuales se
                        alcanzan a generar secuencias de esquemas que hacen un
                        bloque de comportamiento que logra instaurarse en el
                        infante, hasta que se alcanzan un dominio de la acción.
                        Según Perinat (2004), las reacciones circulares
                        descritas identifican una pauta de repetición que logra
                        en el niño una acción que es desarrollada
                        constantemente, y que permite la circularidad de este.
                        Todo este proceso constituye la construcción del
                        conocimiento, que es considerado por Piaget, en la obra
                        de Mussen, P. (1970), como un modo de procesar la
                        información y crear un conocimiento en el niño, a través
                        de múltiples repeticiones de esquemas que se van
                        asimilando, hasta encontrar el punto de desarrollo
                        correcto para la acción determinada.
                      </p>

                      <div class="row mt-3 cuadroGAVI ml-lg-4">
                        <div
                          class="col-lg-3 col-md-3 col-sm-12 col-12 align-items-center d-flex justify-content-center"
                        >
                          <img
                            src="recursos/img/GAVI/Importante.png"
                            alt=""
                            class="img-fluid"
                          />
                        </div>
                        <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                          <p class="tal">¡Importante!</p>
                          <p>
                            En el siguiente video puedes apreciar la segunda
                            parte sobre la teoría de Piaget, explicado por él
                            mismo:
                          </p>
                          <p>
                            YALE UNIVERSITY [Vicente Panuccio]. (28 de mayo de
                            2013). PIAGET explica a PIAGET (2 de 3) [Archivo de
                            video]. Recuperado de
                            <a
                              href="https://www.youtube.com/watch?v=zYnlnYiWfoE&t=13s"
                              target="_blank"
                              >https://www.youtube.com/</a
                            >
                          </p>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-0">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.accordion-3 class="btnColapsable"
                      >Organización y adaptación</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-3"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <h5>Tercer subperíodo</h5>
                      <p>
                        Aquí se descubren las reacciones circulares secundarias,
                        que se proyectan en un tiempo de los primeros diez (10)
                        meses de los niños y niñas. En este trayecto se han
                        realizado los procesos de asimilación y acomodación que
                        hacen posible el surgimiento de conductas dirigidas, que
                        son proyectadas bajo la motivación de los niños, lo que
                        implica la adaptación de la intención sobre la acción.
                        El interés por el ambiente es aquí un fundamento en lo
                        que Mussen, P. (1970) describe como, tras el cambio
                        entre los actos reflejos en los cuales se ejercían
                        acciones como chupar o agarrar, pasan a sentir el
                        entorno. Los niños y las niñas en este tiempo comienzan
                        a despertar su motivación por todo aquello que acontece
                        alrededor de ellos: los sonidos de los juguetes, las
                        texturas de los materiales que son usados en la
                        infancia, los cambios que experimentan las superficies
                        sobre las cuales se ejerce una presión, (como una pelota
                        que al apretarse pierde aire y vuelve a inflarse cuando
                        se suelta). Todas estas pequeñas características de los
                        objetos se convierten en focos de interés para el
                        desarrollo del niño.
                      </p>
                      <p>
                        Las reacciones circulares secundarias dan cuenta del
                        descubrimiento y la búsqueda de repetición de los
                        efectos que hace el niño sobre aquellos materiales con
                        los cuales tiene contacto. Aquí, ya hay unas relaciones
                        cognitivas entre las causas y los efectos. Un ejemplo de
                        ello es cuando los niños y niñas lloran, o realizan un
                        movimiento determinado e identifican que el entorno
                        cambia. Esta vinculación de la causalidad sobre la
                        acción, indica Piaget (2007), genera placer y disfrute
                        en los infantes, por cuanto saben que ejerce una
                        acción-reacción que puede ser motivada o involuntaria.
                        La repetición de patrones hace que sea mágico lo
                        cotidiano, como activar el dispositivo de sonido de un
                        juguete con solo ejercer presión o ver el cambio de un
                        color sobre una superficie con solo tocarla; incluso, el
                        esquema del balbuceo y llorar para lograr una respuesta
                        del otro.
                      </p>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-0">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.accordion-4 class="btnColapsable"
                      >Asimilación y acomodación</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-4"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <h5>Cuarto subperíodo</h5>
                      <p>
                        Como lo explica Perinat (2004), este es el estadio en el
                        cual se logra una coordinación que responde a
                        situaciones determinadas. El desarrollo del infante en
                        este período es marcado por el primer año de vida, en el
                        que comienza a manipular los objetos y a reconocer que
                        para llegar a fines se deben utilizar unos medios. La
                        combinación de esquemas que han tenido unos ciclos de
                        acomodación y asimilación se hacen cada vez más claros.
                        A modo de ilustración, se tienen los obstáculos que
                        deben tener los niños y niñas para alcanzar los
                        objetivos. Ante la pregunta ¿cómo obtener el juguete que
                        no está al alcance de la mano? los niños comenzarán a
                        utilizar diversas estrategias para alcanzarlo como
                        valerse de otro objeto, desplazarse en el espacio,
                        señalar, llorar, etc.
                      </p>
                      <p>
                        La coordinación y el ambiente son señalados por Mussen,
                        P. (1970) como los procesos que permiten el
                        descubrimiento del afuera. ¿Qué pasa cuando los niños
                        descubren que hay un mundo más allá de pequeño entorno?
                        La respuesta es que salen a explorarlo. Esto se logra
                        gracias a que la coordinación de los esquemas que han
                        sido combinados permite que se prologue la extensión
                        entre el espacio propio (conocido y de cuidado) con el
                        otro espacio, donde se encuentran elementos por
                        descubrir, objetos y un impulso en el desarrollo para
                        realizarlo.
                      </p>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-0">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.accordion-5 class="btnColapsable"
                      >Organización y adaptación</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-5"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <h5>Quinto subperíodo</h5>
                      <p>
                        Los primeros 18 meses de vida en los niños y niñas darán
                        lugar al siguiente ciclo denominado Mussen, P. (1970)
                        como
                        <span class="font-italic"
                          >reacciones circulares terciarias</span
                        >. Siguiendo con el descubrimiento en el cuarto período
                        de acción-reacción, se intensificará la búsqueda de
                        reacciones, llevando al niño a la investigación sobre la
                        respuesta de los objetos ante su accionar; vasos que se
                        pueden caer si son impulsados, juguetes que logran
                        descomponerse en partes, cuando se ejecuta una acción
                        sobre determinado botón, la vibración del sonido, etc.
                      </p>
                      <p>
                        Unos de los ejemplos en la teoría para explicar
                        regularmente este ciclo son las propias observaciones
                        que realizaba Piaget sobre su hija cuando su madre la
                        bañaba. Allí se presentaba el juego (múltiples veces
                        ilustrado por el cine) del pato en el agua, en el que al
                        sumergirlo en el agua este vuelve, y este es todo un
                        descubrimiento y novedad para la niña.
                      </p>
                      <p>
                        Algo análogo es lo que ocurre con todos los niños y
                        niñas en este período, pues se ven abocados a
                        experimentar e investigar sobre diferentes elementos
                        como el agua, la luz, el aire, la tierra, etc. Este es
                        un tiempo particularmente de cuidado de los padres hacia
                        los niños, dado que esa búsqueda por la sensación y la
                        experimentación hace que los infantes corran riesgos con
                        los implementos que se ubican en una casa o en el
                        espacio que habitan. El desarrollo cognitivo, en la
                        etapa circular terciaria, es cada vez más veloz y
                        autónomo en relación a la acción que desarrollan. La
                        acomodación y asimilación se amplía, y las estructuras
                        se convierten en estrategias que se van incorporando
                        para llegar a unos fines específicos.
                      </p>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-0">
                  <b-card-header header-tag="header" class="p-0" role="tab">
                    <b-button block v-b-toggle.accordion-6 class="btnColapsable"
                      >Asimilación y acomodación</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-6"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <h5>Sexto subperíodo</h5>
                      <p>
                        Se establece como el final del primer estadio, en el
                        cual se conjugan todos los componentes esenciales para
                        una inteligencia sensoriomotora y la reflexión antes de
                        la acción. La edad de los dos años marca este hito en el
                        desarrollo, pues se han afianzado la relación de
                        acomodación cognitiva y el mundo; allí el niño ha
                        superado el acto reflejo de los primeros subperíodos y
                        puede pensar en la acción antes de ejecutarla. En este
                        orden, la realización de actividades complejas,
                        relacionadas con problemas con objetos, como hacer
                        selecciones determinadas, dividir un objeto en partes y
                        volverlo a reconstruir, hacen parte de este desarrollo
                        cognitivo que es cada vez más evidenciable.
                      </p>
                      <p>
                        También, se presenta un segundo factor que es la
                        imitación diferida, término acuñado por Piaget, y que
                        Mussen, P. (1970) agrega en su obra, como la realización
                        de una serie de acciones que tienen como finalidad
                        imitar lo que acontece a su alrededor. Por ello, no es
                        extraño identificar en el ámbito de las redes sociales
                        que se usan actualmente; centenares de videos en los
                        cuales los niños y niñas imitan a sus padres en
                        diferentes actividades como bailar, cantar, en
                        expresiones kinésicas y en manipulación de objetos. Esta
                        imitación da cuenta de la representación que se va dando
                        en la infancia sobre las conductas que son observadas y
                        que generan placer y disfrute en el niño a la hora de
                        realizarlas.
                      </p>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div class="col-xl-5 col-lg-5 col-12 offset-xl-1 offset-lg-1">
              <p>
                • El período de desarrollo sensoriomotor presenta, desde
                Linares, R. (2005), un primer escenario de competencias básicas
                adquiridas en dos criterios: la acción de la conducta hacia un
                fin específico y el descubrimiento de la estabilidad de los
                objetos. Como se señaló en los subperíodos, los niños y niñas
                van realizando el enlace de acomodación-asimilación, que
                facilita la creación de esquemas que se van adaptando y
                constituyendo en conocimiento. Esto ocurre con la regulación de
                movimientos, la exploración del ambiente y la posibilidad de
                sortear obstáculos para cumplir tareas específicas.
              </p>
              <p>
                • La segunda competencia básica alude específicamente al reto de
                identificar la razón por la cual los objetos permanecen en una
                materialidad. El desarrollo sensoriomotor faculta a que los
                niños, a través de la visión y la motricidad, puedan lograrlo y
                saldar el misterio de qué pasa cuando un objeto no permanece en
                un espacio, ¿ocurre un desplazamiento de este?, ¿un acto de
                magia hizo desaparecer el objeto? Todo esto es analizado por
                Piaget como la conquista cognitiva que se hace para poder lograr
                una representación mental del desplazamiento de los objetos,
                como lo indica en el experimento de Bower, T.
              </p>
              <div class="citacion2 p-4 mb-3">
                <p class="mb-0 pb-0">
                  Tom Bower, a finales de los años 1960, descubrió que si a un
                  niño pequeño (menos de 4 meses) se le presentaba delante un
                  objeto (una pelotita de colores) y, en un momento dado, se
                  bajaba una pantalla ocultándola, los niños manifestaban
                  sorpresa cuando, al levantar la pantalla, la pelotita había
                  desaparecido (Perinat, 2004, pp. 150-151).
                </p>
              </div>
              <p>
                La sorpresa se da en la idea de que el niño buscará el objeto
                que ha desaparecido, pues comprende que no se ha esfumado por
                arte de magia, sino que ha sido ocultado por alguien. Esto se
                logra en el primer año de desarrollo, cuando comienza la
                exploración y la búsqueda en relación al ambiente; por lo tanto,
                habrá una indagación que hará busque a través de diversos
                esquemas para llegar al objeto perdido. Este hallazgo supone un
                triunfo en el desarrollo, evidencia el control sensoriomotor y
                el paso para llegar al siguiente estadio del desarrollo que
                serán las operaciones preoperacionales.
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--Fin Slide 1-->

      <!--Slide 2-->
      <div
        class="swiper-slide overflow-auto swiper-no-swiping"
        data-title="pág. 2"
      >
        <div class="container-fluid margen_principal">
          <div class="row mb-4">
            <div class="col-xl-6 col-lg-6 col-12">
              <h4>2.1.2. Estadio preoperacional</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-12">
              <p>
                Se entiende este estadio como aquel que implica todo el sistema
                de representaciones y origina el conocimiento en el niño. De
                allí deriva la explicación sobre el lenguaje, la creación del
                signo y la representación que se tiene sobre la realidad. Este
                período es expuesto por Piaget, y se percibe en la obra de
                Mussen, P. (1970) como el momento en el cual la inteligencia se
                representa, lo que lleva a operaciones definidas (concretas)
                como la organización de la realidad en clases, series,
                enumeraciones y organización completa del objeto. Este
                componente se designa como desarrollo semiótico en el niño.
              </p>
              <p>
                Para comprender este momento en el desarrollo, hay que
                diferenciar un estadio inicial en la teoría piagetana, fundado
                especialmente en la acción, una que se va haciendo voluntaria
                (reflejo, esquema) y que, finalmente, se encauza en una conducta
                que logra ser llevada a unos fines específicos. El cambio de
                estadio marca una diferencia con la acción, en la medida en que
                comienza un escenario de la representación mental. Esto hace
                parte de la hipótesis de Piaget (2007) sobre una especie de
                almacén o espacio interno que tienen los seres humanos donde se
                va almacenando y procesando la información que es compilada
                sobre el ambiente.
              </p>
            </div>
            <div class="col-xl-5 col-lg-5 col-12 offset-xl-1 offset-lg-1">
              <p>
                En este orden, la representación organiza y abstrae la
                exterioridad para poder aprehenderla y comunicarla; sin embargo,
                en esta teoría se establece que la representación se logra
                gracias a la imitación; este concepto ha sido ampliamente
                discutido y rebatido por disciplinas como la lingüística. Un
                ejemplo de ello es Chomsky (1979), quien advierte que el
                lenguaje no surge ni por imitación, ni por procesos de
                estimulación conductual, así que aspectos como la creatividad,
                la sintaxis y el desarrollo léxico no tienen una correspondencia
                entre la conducta que observa el niño y la imitación que este
                intenta hacer. Para ampliar este estadio, se explicarán los
                procesos de desarrollo que identifica Piaget.
              </p>
            </div>
          </div>
          <div class="row Fondo2Ppal p-3">
            <div class="col-12 mb-3">
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-12">
                  <b class="color1Ppal">Pensamiento representacional</b>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
              <p>
                Como se explicó en el segmento anterior, la representación
                comienza a configurarse en el desarrollo y tiene un espacio
                temporal que abarca de los dos (2) a los siete (7) años en el
                niño. Inicialmente, comienzan las operaciones relacionadas con
                la imitación, que son adquiridas a través del juego simbólico
                (Piaget e Inhelder, 1969). Este concepto se desarrollará con
                mayor profundidad con Bruner (1989), en su trabajo sobre acción
                y pensamiento. En este marco, los niños comienzan en procesos de
                juegos en los cuales se van configurando contextos sociales que
                permiten una adecuación cognitiva. En la simbolización, se
                evidencian aspectos como la creatividad, la imaginación y, por
                ende, la creación de mundos posibles en el niño que estimulan,
                según Piaget e Inhelder (1969), el lenguaje.
              </p>
              <p>
                En este orden, la representación mental es la creación de
                pensamiento anterior al lenguaje y se simboliza a través de
                imágenes mentales que crea el niño sobre su contexto. Esto se
                genera sobre la base de espacios y acciones que no han ocurrido
                o que se desplazan en la temporalidad del sujeto. Esta etapa,
                está marcada principalmente por el egocentrismo, que es
                identificado por Piaget como esa circunstancia en la cual los
                niños y niñas tienen un lenguaje interior, que busca poca
                expresión con el otro y se pude representar en los 2 o 3 años,
                por medio de imágenes que dan cuenta de este proceso interior.
              </p>
            </div>
            <div class="col-xl-5 col-lg-5 col-12 offset-xl-1 offset-lg-1">
              <p>
                Para ilustrar la concepción sobre el lenguaje de Piaget, Niño,
                V. (2007) señala el siguiente esquema:
              </p>
              <h6>
                Tabla 1 <br /><span class="font-italic"
                  >Manifestaciones del lenguaje en Piaget</span
                >
              </h6>

              <div class="tabla1 mt-3 table-responsive">
                <table class="table table-bordered">
                  <tbody>
                    <tr class="EncabezadoTabla">
                      <td class="align-middle pb-0 mb-0 bordeiztabla">
                        <h5 class="text-center">
                          Manifestaciones del lenguaje
                        </h5>
                      </td>
                      <td class="align-middle pb-0 mb-0">
                        <h5 class="text-center">Etapa</h5>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 bg-light">
                        <p>
                          <b>1. Representar algo:</b> se concreta en la idea del
                          significante y significado en el niño.
                        </p>
                        <p>
                          <b>2. Señales de significación:</b> se presenatan los
                          símbolos, icónos, signos e índices.
                        </p>
                        <p>
                          <b>3. Génesis e imitación:</b> aparición del juego
                          simbólico y la imitación diferida.
                        </p>
                        <p>
                          <b>4. Pensamiento:</b> se presentan desde el
                          egocentrismo preconceptual, conceptual, y el
                          razomaniento.
                        </p>
                        <p>
                          <b>5. Lenguaje:</b> adaptación del sistema de signos
                          verbales y no verbales en el niño.
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>Pensamiento simbólico conceptual</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h6>Basada en Niño, V. (2007).</h6>
              </div>
            </div>
            <div class="col-12"><hr class="divisor1" /></div>
            <div class="row">
              <div class="col-12 mb-3">
                <b class="color1Ppal">Conceptos numéricos</b>
                <div class="row">
                  <div class="col-xl-6 col-lg-6">
                    <p class="mt-3">
                      Sumado al descubrimiento semiótico que hacen los niños de
                      la palabra, en la imagen y el significado que se adquiere
                      deviene un segundo paso en el desarrollo y es la
                      concreción numérica. Los principios de números hacen parte
                      de una fase del estadio de desarrollo concreto, en la
                      cual, según Piaget e Inhelder (1969), los niños logran
                      hacer operaciones de los siguientes tipos:
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-12">
                <div class="col-12 d-flex">
                  <span class="numeracionMorada1 mr-2">1</span>
                  <p>
                    Cuentan una serie de elementos como la suma de unidades que
                    llevan a un resultado determinado.
                  </p>
                </div>
                <div class="col-12 d-flex">
                  <span class="numeracionMorada1 mr-2">2</span>
                  <p>
                    Tienen un orden específico para cada uno de los números: los
                    niños adquieren la habilidad de identificar si un número es
                    mayor o menor.
                  </p>
                </div>
                <div class="col-12 d-flex">
                  <span class="numeracionMorada1 mr-2">3</span>
                  <p>
                    No importa el orden en el cual se hará una suma de las
                    unidades.
                  </p>
                </div>
                <div class="col-12 d-flex">
                  <span class="numeracionMorada1 mr-2">4</span>
                  <p>
                    El último número que se dice es mayor que los anteriores.
                  </p>
                </div>
              </div>
              <div class="col-xl-5 col-lg-5 col-12 offset-xl-1 offset-lg-1">
                <p class="mb-4">
                  Las operaciones señaladas pueden presentar transformaciones en
                  el período escolar, de modo que los niños y niñas, al contar
                  una serie de unidades, puedan omitir elementos; también, se
                  encuentran dificultades para llegar a grandes cantidades que
                  superen, por ejemplo, el número de los dedos. Todos estos
                  procesos se van afianzando en la medida en que el estadio del
                  desarrollo concreto se logre manifestar en su totalidad.
                </p>
                <div class="row mt-3 cuadroGAVI ml-lg-4">
                  <div
                    class="col-lg-3 col-md-3 col-sm-12 col-12 align-items-center d-flex justify-content-center"
                  >
                    <img
                      src="recursos/img/GAVI/Observa_que.png"
                      alt=""
                      class="img-fluid"
                    />
                  </div>
                  <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                    <p class="tal">Observa:</p>
                    <p>
                      En el siguiente video puedes apreciar la tercera parte
                      sobre la teoría de Piaget, explicada por él mismo.
                    </p>
                    <p>
                      YALE UNIVERSITY [Vicente Panuccio]. (28 de mayo de 2013).
                      PIAGET explica a PIAGET (3 de 3) [Archivo de video].
                      Recuperado de <br />
                      <span class="url"
                        ><a
                          href="https://www.youtube.com/watch?v=5H-wMcVHaAU"
                          target="_blank"
                          >https://www.youtube.com/</a
                        ></span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Fin Slide 2-->

      <!--Slide 3-->
      <div
        class="swiper-slide overflow-auto swiper-no-swiping"
        data-title="pág. 3"
      >
        <div class="container-fluid margen_principal">
          <div class="row mb-4">
            <div class="col-xl-6 col-lg-6 col-12">
              <h4>2.1.3. Estadio de operaciones concretas</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-5 col-lg-5 col-12">
              <p>
                Se identifica como una de las últimas etapas del desarrollo con
                un rango de los siete (7) a los once (11) años de edad. En este
                período ya hay una formación de la inteligencia que faculta a
                los niños a tener una representación y la lógica. Esta permite
                la realización de sumas, unión de unidades, ordenación,
                seriación y correspondencia de causa-efecto. Con este bagaje, en
                las operaciones concretas se alcanza el nivel de escolaridad
                primario de los niños y niñas. Piaget e Inhelder (1969)
                identifican una serie de componentes que permiten describir el
                desarrollo concreto y que se fundamenta principalmente en la
                flexibilización de pensamiento, que es entendida como la
                capacidad de asimilación que tienen los niños de comprender los
                cambios que se presentan en su contexto inmediato. Las tres
                operaciones que se desarrollan son la seriación, clasificación y
                conservación.
              </p>
            </div>
            <div class="col-xl-6 col-lg-6 col-12 offset-xl-1 offset-lg-1">
              <h6>
                Tabla 2<br /><span class="font-italic"
                  >Tabla de seriación, clasificación y conservación</span
                >
              </h6>

              <div class="tabla1 mt-3 table-responsive">
                <table class="table table-bordered">
                  <tbody>
                    <tr class="EncabezadoTabla">
                      <td class="align-middle pb-0 mb-0 bordeiztabla">
                        <h5 class="text-center">Concepto</h5>
                      </td>
                      <td class="align-middle pb-0 mb-0">
                        <h5 class="text-center">Seriación</h5>
                      </td>
                      <td class="align-middle pb-0 mb-0">
                        <h5 class="text-center">Clasificación</h5>
                      </td>
                      <td class="align-middle pb-0 mb-0">
                        <h5 class="text-center">Conservación</h5>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 Fondo1Ppal">
                        <p class="text-white">Definición</p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Se comprende como el segmento en el cual los niños y
                          niñas pueden organizar los objetos de forma lógica.
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Establece la diferenciación en semejanzas y relaciones
                          que puedan tener los objetos. Esta clasificación puede
                          ser simple, múltiple e inclusión de clases.
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          La conservación explica cómo los objetos permanecen
                          inalterables, pese a los cambios que sobre ellos se
                          genere. La conservación se da en los líquidos, los
                          números, las sustancias, la longitud y el volumen.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 Fondo1Ppal">
                        <p class="text-white">Experimento</p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>Experimento (Rafael Linares, 2005).</p>
                        <p>
                          Piaget, le pedía a los niños ordenar una serie de
                          palos, con los cuales buscaba identificar como hay un
                          cambio progresivo en ellos. Aquí, los niños
                          identificaban de forma lógica cuáles eran mayores y
                          cuáles menores en tamaño.
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          En experimentos, Piaget ubica tres etapas en la
                          clasificación:
                        </p>
                        <p>
                          • Colecciones figurales: no clasifican, sino que se
                          realizan dibujos.
                        </p>
                        <p>
                          • Colecciones no figurales: se organizan las
                          agrupaciones en relación a las dimensiones de los
                          objetos.
                        </p>
                        <p>
                          • Clasificación múltiple: hay una comprensión de
                          inclusión de clases (Mussen, P., 1970).
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Al niño se le muestran grupos de objetos que pueden
                          contener agua, arena, etc. Se acepta que son iguales y
                          se aplican cambios; cuando esto pasa, se verifica con
                          el niño las dimensiones del objeto, para identificar
                          si reconoce o no la conservación en los materiales.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h6>Basada en Linares, R. (2005).</h6>
              </div>
            </div>
            <div class="col-12 mt-3 mb-2">
              <hr class="divisor1 d-xl-block d-lg-block d-none" />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-xl-6 col-lg-6 col-12">
              <h4>2.1.4. Estadio de operaciones formales</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-5 col-lg-5 col-12">
              <p>
                Las operaciones formales marcan el desarrollo de tres procesos
                básicos en los adolescentes: la expresión de la lógica
                proposicional, el razonamiento científico y el razonamiento
                combinatorio. En esta fase del desarrollo, la edad se enmarca en
                los 11 a 12 años hasta la adultez; se trasciende la educación
                secundaria y comienzan los procesos de abstracción general y
                temporal. El pleno desempeño de la lectura y la escritura, el
                acceso a las tecnologías de la información y la socialización
                hacen que el desarrollo de la inteligencia de los adolescentes
                marque un paso de transformación temporal y espacial. Un ejemplo
                de ello ocurre cuando se logra vincular la conexión con
                elementos que no son próximos, como los acontecimientos
                climáticos, fenómenos que trascienden la cotidianidad.
              </p>
            </div>
            <div class="col-xl-6 col-lg-6 col-12 offset-xl-1 offset-lg-1">
              <p>
                La comprensión de estos procesos conlleva una amplitud de
                análisis con relación a lo posible, donde se puede equiparar y
                separar lo real de aquello que no lo es; por ejemplo, en el caso
                de la literatura, los adolescentes pueden hacer la distinción
                entre los sucesos ficcionales y la vida real. Sin embargo, la
                literatura les permite la ampliación del mundo simbólico que
                venía construyéndose desde los estadios preoperacionales. Aquí
                la imaginación y la inmersión de mundos simbólicos permiten
                fraguar un desarrollo cognitivo en el adolescente, que lo
                faculta para lanzar hipótesis sobre un problema, generar
                explicaciones analíticas con la identificación de diferentes
                variables y conjeturar respuestas para la resolución de aspectos
                de su entorno o su imaginación.
              </p>
            </div>
            <div
              class="col-xl-4 col-lg-4 col-12 offset-xl-4 offset-lg-4 mb-xl-0 mb-lg-0 mb-3"
            >
              <audio controls="" class="w-100" controlslist="nodownload">
                <source
                  src="recursos/audio/au_u2_INLIN_slide27.mp3"
                  type="audio/mpeg"
                />
              </audio>
            </div>
            <div class="col-12">
              <hr class="divisor1 mt-5 mb-5 d-xl-block d-lg-block d-none" />
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-12">
              <div class="bordeRedondeado Fondo1Ppal p-3">
                <p class="m-0 p-0 text-white">
                  La definición de las operaciones concretas son, según Piaget,
                  en primer lugar, la capacidad de inferencia que pueda tener el
                  individuo a través de la lógica proposicional, lo que implica
                  reconocer el modo como, a partir de una premisa, se puede
                  ejemplificar en el pensamiento analógico, en el que el sujeto
                  logra identificar la semejanza entre diferentes elementos y el
                  significado de la totalidad (Mussen, P., 1970). En segundo
                  lugar, se comprende el razonamiento científico que tiene su
                  centro en el método hipotético-deductivo, como lo evidencia el
                  experimento de Piaget (2007), en el cual se le entrega a un
                  niño un apoyo sobre dos cuerdas, de las cuales se pueden
                  colgar dos pesos diferenciados.
                </p>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-12 mt-xl-0 mt-lg-0 mt-4">
              <p>
                Con la idea de esa realización de un péndulo se busca que elija
                una de tres variables que harían que funcione el péndulo, estas
                son: la longitud de la cuerda, el peso del objeto y la fuerza de
                impulso utilizada. Al niño se le permite la manipulación de los
                materiales, luego se le pregunta por la respuesta que considere,
                y debe marcar el paso del péndulo. De ello se desprende la
                capacidad cognitiva que se tenga para poder generar hipótesis.
              </p>
              <p>
                En tercer lugar, se encuentra el razonamiento combinado y la
                generación de probabilidades. El primero de ellos obedece a la
                capacidad que tienen los jóvenes de identificar múltiples causas
                que puedan explicar un fenómeno particular. Este razonamiento
                implica hacer todas las combinaciones posibles para identificar
                la probabilidad de un hallazgo, este puede ser la posibilidad de
                lograr un resultado o reconocer un valor aproximado. Por último,
                el pensamiento probabilístico se suma al combinado, por cuanto
                determina, en gran medida, el planteamiento del pensamiento
                concreto.
              </p>
              <p>
                A modo de síntesis, se integra una tabla basada en Linares, R.
                (2005) y Mussen, P. (1970), en la cual se resumen las etapas del
                desarrollo.
              </p>
            </div>
            <div class="col-12">
              <hr class="divisor1 mt-3 mb-3 d-xl-block d-lg-block d-none" />
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-12">
              <h6>
                Tabla 3<br /><span class="font-italic"
                  >Etapas del desarrollo</span
                >
              </h6>
              <div class="tabla1 mt-3 table-responsive">
                <table class="table table-bordered">
                  <tbody>
                    <tr class="EncabezadoTabla">
                      <td class="align-middle pb-0 mb-0 bordeiztabla">
                        <h5 class="text-center">Estadio</h5>
                      </td>
                      <td class="align-middle pb-0 mb-0">
                        <h5 class="text-center">Características</h5>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 Fondo1Ppal">
                        <p class="text-white">
                          Sensoriomotor <br />
                          (0 a los 2 años)
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Determinada, principalmente, por la acción motora en
                          los niños y niñas. Se centra en el manejo de los fines
                          y los medios, y la relación con el objeto.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 Fondo1Ppal">
                        <p class="text-white">
                          Preoperacional <br />
                          (2 a 7 años)
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Descubrimiento de la actividad semiótica; aparece el
                          símbolo, el lenguaje, el pensamiento y la actividad
                          egocéntrica.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 Fondo1Ppal">
                        <p class="text-white">
                          Operaciones concretas <br />
                          (7 a 11 años)
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Se realizan las operaciones de seriación,
                          multiplicación, clasificación y conversación.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pb-0 mb-0 Fondo1Ppal">
                        <p class="text-white">
                          Operaciones formales <br />
                          (11 años en adelante)
                        </p>
                      </td>
                      <td class="pb-0 mb-0 bg-light">
                        <p>
                          Se presenta el manejo de las operaciones superiores a
                          partir del manejo del razonamiento deductivo, la
                          lógica proposicional y la abstracción.
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h6>Basada en Linares, R. (2005) y Mussen, P. (1970).</h6>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
              <div class="row mt-3 cuadroGAVI mt-xl-5 mt-lg-5 mt-0 mb-3">
                <div
                  class="col-lg-3 col-md-3 col-sm-12 col-12 align-items-center d-flex justify-content-center"
                >
                  <img
                    src="recursos/img/GAVI/Sabías_que.png"
                    alt=""
                    class="img-fluid"
                  />
                </div>
                <div class="col-lg-9 col-md-9 col-sm-12 col-12">
                  <p class="tal">Escucha:</p>
                  <p>
                    A través del siguiente podcast se explican los estadios de
                    desarrollo. Te invito a escucharlo atentamente.
                  </p>
                  <p>
                    Medellín, I. (Junio de 2019). Etapas del desarrollo – Jean
                    Piaget [Audio podcast]. Recuperado de
                    <span class="url"
                      ><a
                        href="https://soundcloud.com/itzel-medellin/a1-etapas-del-desarrollo-jean-piaget"
                        target="_blank"
                        >https://soundcloud.com/</a
                      ></span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Fin Slide 3-->
    </div>
  </div>
</template>

<script>
import { SwiperController } from "../assets/RecursosITM/js/Swiper";

export default {
  name: "Tema2_2-1",
  mounted() {
    SwiperController(), (document.title = this.$route.meta.title);
  },
};
</script>